import { gql } from '@apollo/client';

export default gql`
  query lastSyncDate {
    lastSyncDate {
      appliedAt
      createdAt
      receivedAt
    }
  }
`; 